import type { HelpFaqProps } from '@/components/help/HelpFaq';
import { HelpFaq } from '@/components/help/HelpFaq';
import { routes } from '@/routes/routes';
import { Link } from '@tanstack/react-router';

const helpFaqData: HelpFaqProps = {
  title: 'Safety & Privacy',
  subtitle: 'Quality control and supplement safety',
  faq: [
    {
      question: 'Information security',
      answer: (
        <>
          <p>
            All customer data is encrypted from end-to-end. Every EternaLife
            team member is trained to handle protected data and we regularly
            validate our security practices.
          </p>
          <p>
            As a company, EternaLife has never, and will never sell any of our
            customers' information.
          </p>
          <p>
            For more information, please review our{' '}
            <Link to={routes.legal.privacyPolicy} target="_blank">
              privacy policy
            </Link>
            .
          </p>
          <p>
            We care about your privacy and security. To make sure only you and
            authorized users have access to your EternaLife account, we may ask
            you to complete an additional step when you sign in.
          </p>
          <p>
            If you've received a one-time passcode or sign in notification that
            you didn't request, someone else may have access to your password.
            You should reset your EternaLife account password immediately. You
            should also check your other online accounts, like your email
            account, for suspicious activity, and make sure to choose a strong
            and unique password for every one of your online accounts.
          </p>
          <p>
            If you are not able to sign in to EternaLife because you don't have
            access to the email, mobile phone, or other device that we've asked
            you to use to confirm your sign in, contact Customer Service for
            help restoring access.
          </p>
        </>
      ),
    },
    {
      question: 'Reporting a problem',
      answer: (
        <>
          <p>
            If you're concerned with the way a supplements appears in your
            packets — or that your packets could have been tampered with —
            please contact us immediately.
          </p>
          <p>
            Our system keeps an image of each packet that leaves our facility,
            so we can reference what it looked like originally. From there, we
            can recommend a plan of action, which may include sending you a
            replacement packet.
          </p>
        </>
      ),
    },
    {
      question: 'Adverse reactions',
      answer: (
        <>
          <p>
            <strong>
              If you're currently having a painful reaction to your supplements
              please get medical help now.
            </strong>{' '}
            Depending on the severity of your symptoms, you can either reach out
            to your doctor or call 112.
          </p>
          <p>
            Once your own safety is assured, please contact us to let us know
            what happened. An EternaLife pharmacist will assess what happened
            and provide clinical guidance as needed. This may include counseling
            to explain preventative measures.
          </p>
        </>
      ),
    },
    {
      question: 'Talking to a pharmacist',
      answer: (
        <>
          <p>
            <strong>
              If you are experiencing a medical emergency, please contact your
              doctor or call 112 immediately.
            </strong>
          </p>
          <p>
            Our pharmacists are available 7 days a week. If you have an urgent
            clinical need, emailing us at info@eternalife.co.uk is the fastest
            way to reach us.
          </p>
          <p>
            <strong>Daytime phone support</strong>
          </p>
          <p>
            Our normal business hours are Monday to Friday 8:00 AM - 10:00 PM
            BST and Saturday and Sunday 10:00 AM - 8:00 PM BST.
          </p>
          <p>
            <strong>Evening phone support</strong>
          </p>
          <p>
            Please send us a message to info@eternalife.co.uk and a pharmacist
            will get back to you as soon as possible.
          </p>
        </>
      ),
    },
  ],
};

export const SafetyPrivacyPage = () => {
  return <HelpFaq {...helpFaqData} />;
};
